import type { PersonRequestSchemaType } from "@/components/Forms/PersonForm.tsx";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useSavePerson = (): UseMutationResult<
    void,
    Error,
    { personId: string; personUUID: string } & PersonRequestSchemaType
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ personUUID, ...attributes }) => {
            const response = await fetch(apiUrl(`/person/save/${personUUID}`), {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    data: {
                        id: personUUID,
                        type: "person",
                        attributes: attributes,
                    },
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async (_, { personId, personUUID }) => {
            await queryClient.invalidateQueries({
                queryKey: ["people", personId],
            });
            await queryClient.invalidateQueries({
                queryKey: ["person-cases-table-data", personUUID],
            });
        },
    });
};
